import getValueReduxUtil from 'modules/redux/utils/get-value'

export function hasContentReduxUtil (instance) {
  const className = instance?.className
  if (className === 'Article' || className === 'Page') {
    return !!getValueReduxUtil(instance, 'content')
  }

  if (className === 'Motivation') {
    return !!(
      getValueReduxUtil(instance, 'description')
    )
  }

  return !!instance
}
